import http, { defaultConfig, getUniversityUrl } from './http';

export type SurveyType = 'SURVEY' | 'ELECTION' | 'EXAM';

export async function fetchUserSurveys(): Promise<SurveyEntity[]> {
  const baseURL = getUniversityUrl();
  const url = '/rest/users/me/surveys';
  const res = await http.get<HttpResponse<SurveyEntity[]>>(url, defaultConfig(baseURL));
  return res?.data?.payload ?? [];
}

export async function findSurveyById(surveyId: number) {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/surveys/${surveyId}`;
  const res = await http.get<HttpResponse<SurveyEntity>>(url, defaultConfig(baseURL));
  return res?.data?.payload;
}

export async function answerSurvey(surveyId: number, questionAnswers: SurveyAnswer[]) {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/surveys/${surveyId}/answers`;
  const res = await http.post<HttpResponse<any>>(url, { questionAnswers }, defaultConfig(baseURL));
  return res?.data;
}

export async function uploadImage(surveyId: number, file: File) {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/surveys/${surveyId}/images`;
  const data = new FormData();
  data.append('file', file);
  return (await http({
    url,
    method: 'POST',
    data,
    baseURL,
    ...defaultConfig(baseURL, {
      auth: true,
      headers: {
        'Content-Type': 'form-data/multipart'
      }
    })
  }))?.data;
}

export async function verifyImage(surveyId: number) {
  if (isNaN(surveyId)) return null;
  const baseURL = getUniversityUrl();
  const url = `${baseURL}/rest/users/me/surveys/${surveyId}/images/verify`;
  const res = (await http.put<HttpResponse<any>>(url, {}, { ...defaultConfig(baseURL) }));
  return res.data?.payload ?? {} as any;
}
